module.exports = __webpack_public_path__ + "static/media/about img4.72c1bbd5.png";